import { useQuery } from 'react-apollo';

import { albumMembershipGroupExists } from './graphql';

const useAlbumMembershipGroup = ({ entityId, queryOpts = {} }) => {
  const { data: { albumMembershipGroup, loading } = {} } = useQuery(
    albumMembershipGroupExists,
    {
      variables: {
        id: entityId,
      },
      fetchPolicy: 'cache-first',
      skip: !entityId,
      ...queryOpts,
    },
  );

  return {
    albumMembershipGroup,
    loading,
  };
};

export default useAlbumMembershipGroup;
